import * as tslib_1 from "tslib";
import { TableCalculationsUtils } from '../utils/table-calculations.utils';
import * as i0 from "@angular/core";
import * as i1 from "../utils/table-calculations.utils";
var CompanyRankingMapperService = /** @class */ (function () {
    function CompanyRankingMapperService(tableCalculationsUtils) {
        this.tableCalculationsUtils = tableCalculationsUtils;
    }
    CompanyRankingMapperService.prototype.mapToDataTable = function (criteriaGroup, criteriasData) {
        var _this = this;
        return criteriasData.map(function (companyMaintenanceData) {
            var criterias = _this.mapCriterias(criteriaGroup, companyMaintenanceData);
            var totalPoints = _this.tableCalculationsUtils.getTotalPoints(criterias);
            var totalDiscount = _this.tableCalculationsUtils.getTotalDiscount(criterias);
            return {
                id: companyMaintenanceData.company.id,
                name: companyMaintenanceData.company.name,
                avatarUrl: companyMaintenanceData.company.avatarUrl,
                totalPoints: totalPoints,
                totalDiscount: totalDiscount,
                criterias: criterias
            };
        });
    };
    CompanyRankingMapperService.prototype.mapCriterias = function (criteriaGroup, criteriasData) {
        var e_1, _a;
        var result = this.setCriteriaDefaultValues(criteriaGroup.criterias);
        var company = criteriasData.company, __typename = criteriasData.__typename, criteriaDataByCompany = tslib_1.__rest(criteriasData, ["company", "__typename"]);
        var criteriaArray = criteriaGroup.criterias;
        var _loop_1 = function (criteria) {
            var matchingCriteria = criteriaArray.find(function (c) { return c.id === criteria.id; });
            result[matchingCriteria.id] = {
                value: criteria.value,
                ruleName: this_1.transformRuleName(matchingCriteria.ruleName),
                points: this_1.tableCalculationsUtils.calculatePointsForCriteria(this_1.transformRuleName(matchingCriteria.ruleName), criteria.value, matchingCriteria),
                discount: this_1.tableCalculationsUtils.calculateDiscountForCriteria(this_1.transformRuleName(matchingCriteria.ruleName), criteria.value, matchingCriteria)
            };
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(criteriasData.criteriasResult), _c = _b.next(); !_c.done; _c = _b.next()) {
                var criteria = _c.value;
                _loop_1(criteria);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    CompanyRankingMapperService.prototype.transformRuleName = function (ruleName) {
        return {
            accepted_percentage: 'acceptedPercentage',
            refused_percentage: 'refusedPercentage',
            completed_percentage: 'completedPercentage',
            incompleted_percentage: 'incompletedPercentage',
            average_rating: 'averageRating',
            response_on_time_percentage: 'responseOnTimePercentage',
            solution_on_time_percentage: 'solutionOnTimePercentage',
            requested_interval: 'requestedInterval',
            on_negotiation_interval: 'onNegotiationInterval',
            pending_interval: 'pendingInterval',
            scheduled_interval: 'scheduledInterval',
            in_progress_interval: 'inProgressInterval',
            reported_interval: 'reportedInterval',
            response_interval: 'responseInterval',
            solution_interval: 'solutionInterval',
            average_response_time_in_days: 'averageResponseTimeInDays',
            average_close_time_in_days: 'averageCloseTimeInDays',
            response_on_time_percentage_by_range: 'responseOnTimePercentageByRange',
            solution_on_time_percentage_by_range: 'solutionOnTimePercentageByRange'
        }[ruleName] || ruleName;
    };
    CompanyRankingMapperService.prototype.setCriteriaDefaultValues = function (criteriaArray) {
        var e_2, _a;
        var result = {};
        try {
            for (var criteriaArray_1 = tslib_1.__values(criteriaArray), criteriaArray_1_1 = criteriaArray_1.next(); !criteriaArray_1_1.done; criteriaArray_1_1 = criteriaArray_1.next()) {
                var criteria = criteriaArray_1_1.value;
                result[criteria.id] = {
                    value: 0,
                    points: 0
                };
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (criteriaArray_1_1 && !criteriaArray_1_1.done && (_a = criteriaArray_1.return)) _a.call(criteriaArray_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return result;
    };
    CompanyRankingMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyRankingMapperService_Factory() { return new CompanyRankingMapperService(i0.ɵɵinject(i1.TableCalculationsUtils)); }, token: CompanyRankingMapperService, providedIn: "root" });
    return CompanyRankingMapperService;
}());
export { CompanyRankingMapperService };
